import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";

export type Lang = "en" | "ar";

export const LANGUAGES: { code: Lang; label: string; nativeLabel: string }[] = [
  { code: "en", label: "English", nativeLabel: "English" },
  { code: "ar", label: "Arabic", nativeLabel: "العربية" },
];

export function useLanguage() {
  const router = useRouter();
  const { t, i18n } = useTranslation();

  const routeLang = router.query.lang as string | undefined;
  const fallbackLang: Lang = "en";

  const currentLang: Lang =
    (routeLang === "ar" || routeLang === "en"
      ? routeLang
      : (i18n.language as Lang | undefined)) || fallbackLang;

  const isRTL = currentLang === "ar";
  const dir = isRTL ? "rtl" : "ltr";

  const setLang = (nextLang: Lang) => {
    // Update the URL `[lang]` segment so `_app` picks it up and syncs i18n.
    router.push(
      {
        pathname: router.pathname,
        query: { ...router.query, lang: nextLang },
      },
      undefined,
      { shallow: false },
    );
  };

  return {
    lang: currentLang,
    setLang,
    isRTL,
    dir,
    t,
  };
}
